// extracted by mini-css-extract-plugin
export default {"button":"LiquidateInstant_button__4seal","loaderSmall":"LiquidateInstant_loaderSmall__7uv0g"};